import React from 'react';

/**
 * Clickable table header cell. Inactive columns show a faint ↕; the
 * active column shows ▲ / ▼ and ``aria-sort``.
 */
export default function SortableTh({
  label,
  sortKey,
  activeKey,
  direction = 'asc',
  onSort,
  sortable = true,
  align = 'left',
  className = '',
  style,
  children,
  title,
}) {
  const content = children ?? label;
  const alignClass = align === 'right'
    ? 'ty-th-sort--right'
    : align === 'center'
      ? 'ty-th-sort--center'
      : '';
  const mergedStyle = { textAlign: align, whiteSpace: 'nowrap', ...style };

  if (!sortable || !sortKey || typeof onSort !== 'function') {
    return (
      <th className={className || undefined} style={mergedStyle}>
        {content}
      </th>
    );
  }

  const active = activeKey === sortKey;
  const ariaSort = !active ? 'none' : (direction === 'desc' ? 'descending' : 'ascending');
  const classes = ['ty-th-sort', alignClass, active ? 'ty-th-sort--active' : '', className]
    .filter(Boolean)
    .join(' ');
  const sortTitle = title || (
    typeof label === 'string' && label.trim()
      ? `Sort by ${label}`
      : 'Sort this column'
  );

  return (
    <th className={classes} style={mergedStyle} aria-sort={ariaSort}>
      <button
        type="button"
        className="ty-th-sort__btn"
        onClick={() => onSort(sortKey)}
        title={sortTitle}
      >
        <span className="ty-th-sort__label">{content}</span>
        <span className="ty-th-sort__icon" aria-hidden="true">
          {active ? (direction === 'desc' ? '▼' : '▲') : '↕'}
        </span>
      </button>
    </th>
  );
}
